import React from 'react';
import {NotificationsLoadingDialog} from './NotificationsLoadingDialog';
import {NotificationsProvider} from '../context/NotificationsContext';
import {NotificationsCard} from './NotificationsCard';

export function NotificationsPage() {

  return (
    <NotificationsProvider>
      <NotificationsLoadingDialog />
      <NotificationsCard />
    </NotificationsProvider>
  );
}
